import React from "react";
import Chart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import { UtilService } from "../../Utils/UtilService";

type ChartType = "bar" | "line" | "pie" | "donut";
type AlignType = "left" | "center" | "right";

interface ChartInputProps {
  type: ChartType;
  title: string;
  series: any[];
  labels: string[] | number[];
  width?: number | string;
  height?: number | string;
  fillColors?: string[];
  alignTitle?: AlignType;
}

export const GenericChart: React.FC<ChartInputProps> = ({
  type,
  title,
  series,
  labels,
  width,
  height,
  fillColors,
  alignTitle = "left",
}) => {
  const id = UtilService.uuid();
  const options: ApexOptions = {
    chart: { id, toolbar: { show: false } },
    title: { text: title, align: alignTitle },
    fill: { colors: fillColors },
    labels: type === "pie" || type === "donut" ? (labels as string[]) : [],
    xaxis: type === "bar" || type === "line" ? { categories: labels } : {},
    legend: { position: "bottom", horizontalAlign: "center" },
    responsive: [
      {
        options: {
          legend: {
            position: "bottom",
            horizontalAlign: "center",
          },
        },
      },
    ],
  };

  return (
    <div className="bg-white shadow-sm border rounded-lg p-6">
      <Chart
        options={options}
        series={series}
        type={type}
        width={width}
        height={height}
      />
    </div>
  );
};
